import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import api from 'atg/api/API';
import {
  BarBetTable,
  createBetData,
  OneColumnPopupBetTable,
  TwoColumnPopupBetTable,
} from 'atg/components/betHeader/BetInfoTable';
import { showLockedAlertDialog } from 'atg/redux/actions';
import { formatDateTime } from 'atg/utils/Utils';
import BetHeader from 'shared/components/betHeader/BetHeader';
import BetHeaderItem from 'shared/components/betHeader/BetHeaderItem';
import BetInfo from 'shared/components/betHeader/BetInfo';
import LockButton from 'shared/components/betHeader/LockButton';
import MenuButton from 'shared/components/betHeader/MenuButton';
import SystemTitle from 'shared/components/betHeader/SystemTitle';
import PageMeta from 'shared/components/PageMeta';
import VisibilityToggle from 'shared/components/VisibilityToggle';
import {
  showAlertDialog,
  showAtgShareDialog,
  showAtgTemplateDialog,
  showConfirmDialog,
  showErrorDialog,
} from 'shared/redux/actions';
import {
  settings as settingsSelectors,
  user as userSelectors,
} from 'shared/redux/selectors';
import { getElementBottom } from 'shared/utils/dom';
import { getText } from 'shared/utils/Text';
import { getUrl } from 'shared/utils/urls';

import ReductionSummaryContainer from './ReductionSummaryContainer';

const mapStateToProps = state => ({
  manualUpdateMode: settingsSelectors.isManualMode(state),
  isLoggedIn: userSelectors.isLoggedIn(state),
  hasSubscription: userSelectors.hasSubscription(state),
  hasWizEditorRole: userSelectors.hasRole('ROLE_WIZ_EDITOR')(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showAtgShareDialog,
      showAtgTemplateDialog,
      showConfirmDialog,
      showAlertDialog,
      showErrorDialog,
      showLockedAlertDialog,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class BetHeaderContainer extends Component {
    static propTypes = {
      jokerController: PropTypes.object.isRequired,
      showErrorDialog: PropTypes.func.isRequired,
      showAtgShareDialog: PropTypes.func.isRequired,
      showAtgTemplateDialog: PropTypes.func.isRequired,
      betDataInvalid: PropTypes.bool.isRequired,
      error: PropTypes.object,
      indicator: PropTypes.oneOf(['warning', 'spinner', null]),
      reductionMenuVisible: PropTypes.bool,
      manualUpdateMode: PropTypes.bool,
    };

    static defaultProps = {
      reductionMenuVisible: false,
    };

    state = {
      rankingReuseData: undefined,
    };

    UNSAFE_componentWillMount() {
      this.populateState(this.props);
    }

    componentWillUnmount() {
      window.clearTimeout(this.timer);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.populateState(nextProps);
    }

    populateState(props) {
      const { jokerController } = props;
      const { betInformation } = api;
      const betConfig = betInformation.getBetConfig();
      const betKey = betInformation.getBetKey();
      const betId = betInformation.getID();

      if (
        this.state.isLocked === false &&
        betConfig.isLocked() === true &&
        !betConfig.getLockTime()
      ) {
        betConfig.setLockTime(Date.now());
      }

      let state = {
        isShared: jokerController.isSharedBetActive(),
        betName: betConfig ? betConfig.getName() : '',
        isLocked: betConfig.isLocked(),
        lockTime: betConfig.getLockTime(),
        betData: createBetData(api),
        betId,
        rankingReuseData:
          betId === this.state.betId ? this.state.rankingReuseData : undefined,
      };

      if (betKey) {
        api.loadBetKeyInfo(betKey, (betKeyInfo, isSync) => {
          if (betKeyInfo) {
            const titleInfo = `${getText(
              `bet-type-long_${betKey.getBetType().toLowerCase()}`,
            )} / ${betKeyInfo.getTrack().getName()} / ${formatDateTime(
              betKeyInfo.getTime(),
            )}`;
            if (isSync) {
              state = {
                ...state,
                titleInfo,
              };
            } else {
              this.setState({ titleInfo });
            }
          }
        });
      }

      this.setState(state);
    }

    handleRootRef = ref => {
      this.rootNode = ref;
    };

    onMenuButtonClick = () => {
      const { jokerController } = this.props;
      const position = {
        left: this.rootNode.offsetLeft,
        top: getElementBottom(this.rootNode),
      };
      jokerController.onTopInfoMenuPressed(position);
    };

    onErrorIndicatorClick = () => {
      const { error, showErrorDialog } = this.props;
      const errors = Array.isArray(error) ? error : [error];
      for (const err of errors) {
        showErrorDialog({
          message: err.getMessage(),
          details: err.getDetails(),
          logNumber: err.getLogNumber(),
        });
      }
    };

    onSettingsClick = () => {
      this.props.jokerController.openBetConfigDialog();
    };

    onTemplateClick = () => {
      this.props.showAtgTemplateDialog({
        betType: api.betInformation.getBetKey().getBetType(),
      });
    };

    onDuplicateClick = () => {
      const {
        jokerController,
        showConfirmDialog,
        isLoggedIn,
        hasSubscription,
      } = this.props;

      if (!isLoggedIn) {
        showConfirmDialog({
          title: getText('dialog-duplicate-warning-header'),
          details: getText('dialog-duplicate-warning-body'),
          positive: getText('login-button'),
          url: getUrl.login(window.location.pathname),
          target: '_self',
        });
      } else if (!ALLOW_FREEMIUM_HORSE_BETTING && !hasSubscription) {
        showConfirmDialog({
          title: getText('dialog-duplicate-warning-header'),
          details: getText('dialog-duplicate-warning-body-logged-in'),
          positive: getText('dialog-duplicate-warning-subscription-action'),
          url: '/abonnemang',
          target: '_self',
        });
      } else {
        showConfirmDialog({
          title: getText('dialog-archive-confirm-duplicate'),
          helpHeader: getText('dialog-duplicate-help-header'),
          helpBody: getText('dialog-duplicate-help-body'),
          onConfirm: () => {
            jokerController.duplicateArchivedBet(api.betInformation);
          },
        });
      }
    };

    onShareClick = () => {
      this.props.showAtgShareDialog(this.state.betId);
    };

    onPublishWizBet = () => {
      this.props.showConfirmDialog({
        title: getText('dialog-publish-wiz-confirm-title'),
        onConfirm: () => {
          api.publishWizRanking({ betId: this.state.betId }, () => {
            this.props.showAlertDialog({
              title: getText('dialog-publish-wiz-alert-success'),
            });
          });
        },
      });
    };

    onLockChange = () => {
      const { jokerController } = this.props;
      const { isLocked } = this.state;
      jokerController.onTopInfoLockChange(!isLocked);
    };

    onUpdateDividendClick = () => {
      const { jokerController } = this.props;
      jokerController.updateDividendCalculation();
    };

    onSortSystem = rankingType => {
      const { jokerController, showLockedAlertDialog } = this.props;
      const { isLocked } = this.state;
      if (isLocked) {
        showLockedAlertDialog();
        return;
      }
      jokerController.onResetBetRankingAllRowsPressed(rankingType);
    };

    setRankingReuseData = rankingReuseData =>
      this.setState({ rankingReuseData });

    applyRankingReuse = item => {
      const { showLockedAlertDialog } = this.props;
      const { isLocked } = this.state;
      if (isLocked) {
        showLockedAlertDialog();
        return;
      }
      api.applyRankingReuseRequest(item);
    };

    fetchRankingReuse = () => {
      !this.state.rankingReuseData &&
        api.getLoadRankingReuseRequest(this.setRankingReuseData).start();
    };

    render() {
      const {
        jokerController,
        betDataInvalid,
        reductionMenuVisible,
        indicator,
        error,
        manualUpdateMode,
        hasWizEditorRole,
      } = this.props;

      const {
        isShared,
        betData,
        betName,
        titleInfo,
        isLocked,
        lockTime,
        rankingReuseData,
      } = this.state;

      const isLoadingBet = indicator === 'spinner';

      return (
        <VisibilityToggle
          render={({
            visible: betPopupVisible,
            onToggleClick: onToggleBetPopup,
            insideRefHandler: betPopupRefHandler,
          }) => (
            <BetHeader
              fullWidth
              theme="atg"
              className={classnames({
                'is-shared': isShared,
              })}
              refHandler={this.handleRootRef}
            >
              <PageMeta
                title={`${betName}${titleInfo ? `: ${titleInfo}` : ''}`}
              />

              <BetHeaderItem className="betheader-item--menu bet-menu">
                <MenuButton
                  active={reductionMenuVisible}
                  onClick={this.onMenuButtonClick}
                  label={jokerController.getCurrentReductionViewMenuTitle()}
                />
              </BetHeaderItem>

              <BetInfo
                popupVisible={betPopupVisible}
                onTogglePopup={onToggleBetPopup}
                popupRefHandler={betPopupRefHandler}
                indicator={isLoadingBet && manualUpdateMode ? null : indicator}
                onIndicatorClick={error ? this.onErrorIndicatorClick : null}
                renderBetData={() => (
                  <BarBetTable
                    betData={betData}
                    invalid={
                      isLoadingBet && manualUpdateMode ? false : betDataInvalid
                    }
                  />
                )}
                renderPopupBetData={() => [
                  <OneColumnPopupBetTable
                    key="narrow"
                    betData={betData}
                    invalid={
                      isLoadingBet && manualUpdateMode ? false : betDataInvalid
                    }
                  />,
                  <TwoColumnPopupBetTable
                    key="wide"
                    betData={betData}
                    invalid={
                      isLoadingBet && manualUpdateMode ? false : betDataInvalid
                    }
                  />,
                ]}
                renderPopupReductionSummary={(visible, onUpdate) => (
                  <ReductionSummaryContainer
                    key="reductions"
                    visible={visible}
                    invalid={betDataInvalid}
                    onUpdateDividendClick={this.onUpdateDividendClick}
                    onUpdate={onUpdate}
                  />
                )}
              />

              <LockButton
                isLocked={isLocked}
                enabled={!isLoadingBet && !isShared}
                lockTime={lockTime}
                onChange={this.onLockChange}
              />

              <SystemTitle
                name={betName}
                info={titleInfo}
                betType={api.betInformation.getBetKey().getBetType()}
                isShared={isShared}
                isLoading={isLoadingBet}
                renderMobileBetData={() => (
                  <OneColumnPopupBetTable
                    betData={betData}
                    invalid={betDataInvalid}
                  />
                )}
                onSettingsClick={this.onSettingsClick}
                onTemplateClick={this.onTemplateClick}
                onDuplicateClick={this.onDuplicateClick}
                onPublishWizClick={
                  hasWizEditorRole ? this.onPublishWizBet : undefined
                }
                onShareClick={this.onShareClick}
                onInfoClick={onToggleBetPopup}
                onSortSystem={this.onSortSystem}
                fetchRankingReuse={this.fetchRankingReuse}
                applyRankingReuse={this.applyRankingReuse}
                rankingReuseData={rankingReuseData}
              />
            </BetHeader>
          )}
        />
      );
    }
  },
);
